import './App.css';
import Home from './components/Home';

function App():JSX.Element {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
